export default __webpack_public_path__ + "static/media/7.145d0d3b.jpeg";